export function checkIsDataObfuscated(
  value: string | undefined | null,
  initialRun: boolean | undefined
): boolean {
  const isDataObfuscated = value && value.includes('***') && initialRun;

  return Boolean(isDataObfuscated);
}
